"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { Flex, Tag as ChakraTag, forwardRef, Box, useMultiStyleConfig, } from "@chakra-ui/react";
import { ButtonVariant } from "../Button";
import { IconButton } from "../IconButton";
import { TagVariant } from "./Tag.types";
import SvgSpriteConsumer from "../SvgSprite/SvgSpriteConsumer";
import { getTagHeight } from "./helper";
const LeftIcon = ({ leftIcon, variant, }) => {
    const styles = useMultiStyleConfig("Tag", { variant });
    return (_jsx(Flex, Object.assign({ sx: styles.leftIcon, className: "tag-left-icon" }, { children: leftIcon })));
};
function retrieveClipPathConfig(isReadOnly, size = "lg") {
    return isReadOnly
        ? {
            "--button-height": getTagHeight(size),
            "--corner-offset": "calc(var(--button-height) / 3)",
            clipPath: "polygon(0% 0%, 100% 0, 100% calc(100% - var(--corner-offset)), calc(100% - var(--corner-offset)) 100%, 0% 100%)",
        }
        : {};
}
const Tag = forwardRef((_a, ref) => {
    var { onSelect, isSelected, onClose, children, leftIcon, ellipsis, maxWidth = "100%", readonlyCustomColor, isReadOnly = false, size = "lg" } = _a, rest = __rest(_a, ["onSelect", "isSelected", "onClose", "children", "leftIcon", "ellipsis", "maxWidth", "readonlyCustomColor", "isReadOnly", "size"]);
    const styles = useMultiStyleConfig("Tag", {
        ellipsis,
        maxWidth,
        isReadOnly,
        customColor: isReadOnly ? readonlyCustomColor : null,
    });
    const clipPath = useMemo(() => retrieveClipPathConfig(isReadOnly, size), [size, isReadOnly]);
    if (isSelected) {
        return (_jsxs(ChakraTag, Object.assign({ ref: ref, as: "button", onClick: onSelect }, rest, { size: size, variant: TagVariant.SELECTED, sx: clipPath }, { children: [leftIcon && (_jsx(LeftIcon, { leftIcon: leftIcon, variant: TagVariant.SELECTED })), _jsx(Box, Object.assign({ sx: styles.text }, { children: children }))] })));
    }
    return onSelect ? (_jsxs(ChakraTag, Object.assign({ ref: ref, as: "button", onClick: onSelect }, rest, { size: size, variant: TagVariant.SELECT, sx: clipPath }, { children: [leftIcon && (_jsx(LeftIcon, { leftIcon: leftIcon, variant: TagVariant.SELECT })), _jsx(Box, Object.assign({ sx: styles.text }, { children: children }))] }))) : (_jsxs(ChakraTag, Object.assign({ ref: ref }, rest, { size: size, variant: TagVariant.DEFAULT, sx: clipPath }, { children: [leftIcon && (_jsx(LeftIcon, { leftIcon: leftIcon, variant: TagVariant.DEFAULT })), _jsx(Box, Object.assign({ sx: styles.text }, { children: children })), onClose ? (_jsx(IconButton, { ml: "1", size: "sm", variant: ButtonVariant.ICON, "aria-label": "close", onClick: onClose, icon: _jsx(SvgSpriteConsumer, { svgId: "delete16", size: 16 }) })) : null] })));
});
Tag.displayName = "Tag";
export default Tag;
//# sourceMappingURL=Tag.js.map